export default __webpack_public_path__ + "static/health-safety-2cc891cfe1f0bcf54f9af47921c7b7f0.jpg";